import { createFileRoute } from "@tanstack/react-router"
import { MessengerConfiguration } from "modules/settings/components/integrations/messenger"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/messenger")({
  component: MessengerConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.messenger.title"),
    })
  },
})
